import Utils from './basic.utils' // 工具库
import Logger from './logger' // 日志库
import Moment from 'moment'

export default {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      $utils: {
        get: function get () {
          return Utils
        }
      },
      $log: {
        get: function get () {
          return Logger
        }
      },
      $moment: {
        get: function get () {
          return Moment
        }
      }
    })
  }
}
